export enum ModalSteps {
  mobileInitial = 'mobileInitial',
  holidayTypes = 'holidayTypes',
  destinations = 'destinations',
  hotelBrands = 'hotelBrands',
  travellers = 'travellers',
}
